<template>
  <div class="col-lg-12 control-section h100-40 h-scroll">
    <div class='content-wapper h100' >
      <ejs-treegrid :dataSource='dataOfList' idMapping='id' parentIdMapping='parentItem' hasChildMapping='isParent' :treeColumnIndex='0'>
        <e-columns>
          <e-column field='neName' :headerText='$t("Pm.resource_name")' clipMode="EllipsisWithTooltip" width='24%'></e-column>
          <e-column field='neType' :headerText='$t("Pm.resourceType")' clipMode="EllipsisWithTooltip" textAlign='Center' width='24%'></e-column>
          <e-column field='measureObjectTypeName' :headerText='$t("Pm.measureObjName")' clipMode="EllipsisWithTooltip" textAlign='Center' width='24%'></e-column>
          <e-column field='meterTimePeriod' :headerText='$t("Pm.measureCycle")' clipMode="EllipsisWithTooltip" textAlign='Center' width='27%' :valueAccessor='cycleFormatForTimeMeter'></e-column>
        </e-columns>
      </ejs-treegrid>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeasureListForCreate',
  data() {
    return {
      dataOfList: [],
      meterTimePeriods: new Map()
        .set(1, this.$t('Pm.fiveMinutes'))
        .set(2, this.$t('Pm.fifteenMinutes'))
        .set(4, this.$t('Pm.thirtyMinutes'))
        .set(8, this.$t('Pm.oneHour'))
        .set(16, this.$t('Pm.oneDay')),
    };
  },
  methods: {
    cycleFormatForTimeMeter(field, cycleData) {
      return this.meterTimePeriods.get(cycleData[field]);
    }
  }
};
</script>

<style>

</style>
